const desktopNavMenus = () => {
  const body = document.querySelector('body');

  const closeAllMenus = () => {
    // Remove page overlay
    body.classList.remove('nav-menu-dropdown');
    const mainMenuItems = document.querySelectorAll('.primary-nav-list .subnav');
    // Set default content for each menu
    for (let i = 0; i < mainMenuItems.length; i++) { /* eslint-disable-line no-plusplus */
      mainMenuItems[i].classList.remove('is-active');
      if (mainMenuItems[i].querySelector('button') !== null) {
        mainMenuItems[i].querySelector('button').setAttribute('aria-expanded', 'false');
      }
    }
  };

  const closeMenuOnBodyClick = (event) => {
    if (event.target.closest('.subnav') === null) {
      closeAllMenus();
      document.querySelector('body').removeEventListener('click', closeMenuOnBodyClick);
    }
  };

  const onMenuItemMouseEnter = (menuItem) => {
    // console.log('onMenuItemMouseEnter');
    // closeSiblingMenus(menuItem.parentNode.parentNode);
    closeAllMenus();
    menuItem.parentNode.classList.add('is-active');
    menuItem.setAttribute('aria-expanded', 'true');
    body.addEventListener('click', closeMenuOnBodyClick);
    body.classList.add('nav-menu-dropdown');
  };

  const onMenuItemMouseLeave = (menuItem) => {
    // console.log('onMenuItemMouseLeave');
    // Remove focus, if set
    document.activeElement.blur();
    menuItem.parentNode.classList.remove('is-active');
    menuItem.setAttribute('aria-expanded', 'false');
    body.removeEventListener('click', closeMenuOnBodyClick);
    body.classList.remove('nav-menu-dropdown');
  };

  const onMenuItemClick = (menuItem) => {
    // console.log('onMenuItemClick');
    if (menuItem.parentNode.classList.contains('is-active')) {
      menuItem.parentNode.classList.remove('is-active');
      menuItem.setAttribute('aria-expanded', 'false');
      body.removeEventListener('click', closeMenuOnBodyClick);
      body.classList.remove('nav-menu-dropdown');
    } else {
      // closeSiblingMenus(menuItem.parentNode.parentNode);
      closeAllMenus();
      menuItem.parentNode.classList.add('is-active');
      menuItem.setAttribute('aria-expanded', 'true');
      body.addEventListener('click', closeMenuOnBodyClick);
      body.classList.add('nav-menu-dropdown');
    }
  };

  let collectedEvents = [];

  const selectEventHandler = () => {
    setTimeout(() => {
      // If click present, route to click event
      let active = collectedEvents.find(item => item.type === 'click');
      if (active) {
        onMenuItemClick(active.menuItem);
      } else {
        // Otherwise, use last event in array
        active = collectedEvents[collectedEvents.length - 1];
        if (active.type === 'mouseenter') {
          onMenuItemMouseEnter(active.menuItem);
        } else if (active.type === 'mouseleave') {
          onMenuItemMouseLeave(active.menuItem);
        }
      }
      // Otherwise chose last event handler in list
      collectedEvents = [];
    }, 100);
  };

  const manageMenuEvents = (menuItem, type) => {
    if (collectedEvents.length === 0) {
      selectEventHandler();
    }
    collectedEvents.push({
      type,
      menuItem,
    });
  };

  [].map.call(document.querySelectorAll('.primary-nav-list .subnav > button'), menuItem => (
    menuItem.addEventListener('click', (event) => {
      manageMenuEvents(menuItem, event.type);
    })
  ));
  [].map.call(document.querySelectorAll('.primary-nav-list .subnav > button'), menuItem => (
    menuItem.parentNode.addEventListener('mouseenter', (event) => {
      manageMenuEvents(menuItem, event.type);
    })
  ));
  [].map.call(document.querySelectorAll('.primary-nav-list .subnav > button'), menuItem => (
    menuItem.parentNode.addEventListener('mouseleave', (event) => {
      manageMenuEvents(menuItem, event.type);
    })
  ));
  [].map.call(document.querySelectorAll('.primary-nav-list .dd-nav'), dropdown => (
    dropdown.addEventListener('mouseleave', () => {
      closeAllMenus();
      body.removeEventListener('click', closeMenuOnBodyClick);
      body.classList.remove('nav-menu-dropdown');
    })
  ));
};

export default desktopNavMenus;
